var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProjectDetailsDialog',{attrs:{"show":_vm.showDialog},on:{"cancel":function($event){_vm.showDialog = false},"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }